/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 32
// module chunks = 1